import React from 'react'
import PropTypes from 'prop-types'
import { Text, Grid, Image } from '@chatterbug/aaron'

import {
  leftArrowGray,
  leftArrowBlack,
  rightArrowGray,
  rightArrowBlack,
} from './assets'
import {
  getShowNumber,
  getShowEllipseAtEnd,
  getShowEllipseAtStart,
  getGridColumnsNumber,
} from './util'

const Pagination = ({
  numOfSteps,
  currentStep,
  onChangeStep,
  hasNextPage,
  pageLimit = 5,
}) => {
  if (!numOfSteps || numOfSteps <= 1) {
    return null
  }

  return (
    <Grid
      columns={getGridColumnsNumber(currentStep, pageLimit, numOfSteps)}
      justifyItems="center"
      alignItems="center"
      textAlign="center"
    >
      <Image
        sx={{ cursor: currentStep > 1 ? 'pointer' : '' }}
        onClick={() => {
          if (currentStep > 1) {
            onChangeStep(currentStep - 1)
          }
        }}
        src={currentStep > 1 ? leftArrowBlack : leftArrowGray}
      />
      {[...new Array(numOfSteps)].map((_, index) => {
        const step = index + 1
        // show last 3 if currentStep is in that zone (out of start, or before end)
        const showNumber = getShowNumber({
          numOfSteps,
          step,
          currentStep,
          pageLimit,
        })
        const showEllipseAtStart = getShowEllipseAtStart(
          numOfSteps,
          step,
          currentStep
        )
        const showEllipseAtEnd = getShowEllipseAtEnd(
          numOfSteps,
          step,
          currentStep
        )
        return (
          <React.Fragment key={step}>
            {showEllipseAtStart && <Text mt="-2px">{'...'}</Text>}
            {showNumber && (
              <Text
                mt="-2px"
                sx={{ cursor: 'pointer' }}
                color={step === currentStep ? ' #000000' : '#95989D'} //gray60
                onClick={() => {
                  onChangeStep(step)
                }}
              >
                {step}
              </Text>
            )}
            {showEllipseAtEnd && <Text mt="-2px">{'...'}</Text>}
          </React.Fragment>
        )
      })}
      <Image
        disabled={!hasNextPage}
        onClick={() => {
          if (!hasNextPage) {
            return
          }
          onChangeStep(currentStep + 1)
        }}
        src={hasNextPage ? rightArrowBlack : rightArrowGray}
        sx={{ cursor: hasNextPage ? 'pointer' : '' }}
      />
    </Grid>
  )
}

Pagination.propTypes = {
  numOfSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  onChangeStep: PropTypes.func.isRequired,
  hasNextPage: PropTypes.bool.isRequired,
  pageLimit: PropTypes.number,
}

export default Pagination
